module.exports = __webpack_public_path__ + "static/media/Dual_6050.7e4b8abe.jpg";